import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ContactoModel } from '../../models/contacto-model';
import { ModelHelpers } from '../../models/ModelHelpers';
import { AuthService } from '../../services/auth.service';
import { ContactosService } from '../../services/contactos.service';
import { ToastrService } from 'ngx-toastr';
import { GlobalService } from '../../services/global.service';

@Component({
  selector: 'app-selector-contactos-edit',
  templateUrl: './selector-contactos-edit.component.html',
  styleUrls: ['./selector-contactos-edit.component.scss']
})
export class SelectorContactosEditComponent implements OnInit {

  formGroup: FormGroup;
  title = 'Crear';
  isNewElement: boolean;

  id: number;
  isModal: boolean;
  errorMessage: any;
  prescriptorId: any;
  contactosSeleccionados: any;
  tempId: string = ''
  model: ContactoModel = new ContactoModel();
  comunidades: any[] = [];
  provincias: any[] = [];

  constructor(private _fb: FormBuilder,
    private _avRoute: ActivatedRoute,
    private _contactosService: ContactosService,
    private _authService: AuthService,
    private _router: Router,
    public dialogRef: MatDialogRef<SelectorContactosEditComponent>,
    private _location: Location,
    private toastrService: ToastrService,
    private _globalService: GlobalService) {
    if (this._avRoute.snapshot.params['id']) {
      this.id = this._avRoute.snapshot.params['id'];
    }

    this.formGroup = this._fb.group({
      id: 0,
      nombre: [''],
      apellidos: [''],
      cargo: [''],
      disciplinaProfesional: [''],
      telefono: [''],
      telMovil: [''],
      email: [''],
      direccion: [''],
      localidad: [''],
      codPostal: [''],
      comunidadAutonomaId: [null],
      provinciaId: [null],
      pais: [''],
    });
  }

  ngOnInit() {
    this.loadCombos();
    if (this.prescriptorId === null || this.prescriptorId === undefined || this.prescriptorId === '') {
      // console.log(this.model)
      this.formGroup.patchValue(this.model);
    } else {
      if (this.id > 0) {
        this.isNewElement = false;
        this.title = 'Editar';
        this._contactosService.getContactoById(this.id)
          .subscribe((resp: any) => {
            if (resp.comunidadAutonomaId) {
              this.loadProvincias(resp.comunidadAutonomaId);
              this.formGroup.get('provinciaId').enable();
            }
            this.formGroup.patchValue(resp, { emitEvent: false });
          }, error => {
            this.errorMessage = error;
            console.error(error);
          });
      } else {
        this.isNewElement = true;
      }
    }

    this.formGroup.get('comunidadAutonomaId').valueChanges.subscribe(comunidadId => {
      this.provincias = []; // Limpiamos las provincias al cambiar la comunidad
      this.formGroup.get('provinciaId').setValue(null); // Limpiamos la provincia seleccionada
      if (comunidadId) {
        this.loadProvincias(comunidadId);
        this.formGroup.get('provinciaId').enable();
      } else {
        this.formGroup.get('provinciaId').disable();
      }
    });
  }

  loadCombos() {
    this._globalService.getComunidades().subscribe(
      data => this.comunidades = data,
      error => console.error('Error al cargar las comunidades: ', error)
    );
  }

  loadProvincias(comunidadId: number) {
    this._globalService.getProvincias(comunidadId).subscribe(
      data => this.provincias = data,
      error => console.error('Error al cargar las provincias: ', error)
    )
  }

  closeDialog() {
    this.dialogRef.close();
  }

  cancel() {
    if (!this.isModal) {
      this._location.back();
    } else {
      this.closeDialog();
    }
  }

  save() {
    if (!this.formGroup.valid) {
      return;
    }
    let model = new ContactoModel();

    model = {
      ...this.model,
      ...this.formGroup.value
    }

    console.log(model)
    console.log(this.formGroup.value)

    if (this.prescriptorId === undefined || this.prescriptorId === null || this.prescriptorId === '') {
      if (model.id != 0) {
        // console.log(model)
        this._contactosService.put(model)
          .subscribe((data) => {
            if (!this.isModal) {
              this._location.back();
            } else {
              this.dialogRef.close(model)
            }
          }, error => {
            this.errorMessage = error;
            const mensaje = error && error.error && error.error.mensaje ? error.error.mensaje : 'Error al guardar contacto';
            this.toastrService.error(mensaje, 'Cerrar');
          });

      }
      // console.log(model)
      model.isNuevo = true;
      model.tempId = this.tempId;
      this.dialogRef.close(model);
    } else {
      if (this.isNewElement) {
        this._contactosService.post(model, this.prescriptorId)
          .subscribe((data) => {
            if (!this.isModal) {
              this._location.back();
            } else {
              this.closeDialog();
            }
          }, error => {
            this.errorMessage = error;
            const mensaje = error && error.error && error.error.mensaje ? error.error.mensaje : 'Error al guardar contacto';
            this.toastrService.error(mensaje, 'Cerrar');
          });
      } else {
        this._contactosService.put(model)
          .subscribe((data) => {
            if (!this.isModal) {
              this._location.back();
            } else {
              this.closeDialog();
            }
          }, error => {
            this.errorMessage = error;
            const mensaje = error && error.error && error.error.mensaje ? error.error.mensaje : 'Error al guardar contacto';
            this.toastrService.error(mensaje, 'Cerrar');
          });
      }
    }

  }

  get nombre() { return this.formGroup.get('nombre'); }
}

